import { filter } from 'lodash';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
// material
import {
    Alert,
    Autocomplete,
    Card,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TablePagination,
    TableRow,
    TextField,
    Typography,
    Stack,
    Button,
    Container,
    Box,
    Link,
    Grid,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// components
import clientApi from 'src/api/clients';
import { getCamerasList, getServerList, getTimezoneList } from 'src/api/analytics';
import { setNewDevice } from 'src/api/devices';
import { getClientProperties } from 'src/api/ShiftMaster';
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import {
    CameraMoreMenu,
    CameraForm,
    CameraAlert
} from '../sections/cameras';

import { ListHead, ListToolbar } from '../components/table'
// mock
import useCameras from '../api/useCameras'


// ----------------------------------------------------------------------

const TABLE_HEAD = [
    { id: 'deviceid', label: 'Camera Id', alignRight: false },
    { id: 'devicename', label: 'Camera Name', alignRight: false },
    { id: 'substream', label: 'Stream URL', alignRight: false },
    { id: 'status', label: 'Status', alignRight: false }    
  ];

if (localStorage.getItem('ID') === '2')
    TABLE_HEAD[4] = { id: '', label: 'Action', alignRight: false }

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    if (query) {
        return filter(array, (_user) => `${_user.devicename} ${_user.deviceid} ${_user.substream} ${Number(_user.Status) === 1 ? 'online active': 'offline inactive'}`.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
    return stabilizedThis.map((el) => el[0]);
}

const CAMERA_DEFAULT_FORM = {
    clientid: '883',
    locationid: '',
    CameraView: '',
    server_id: '',
    Serverport: '',
    TimezoneId: '',
    MainStream: '',
    Category: '2',
    substream: '',
    ReStream: '',
    LocalDeviceName: '',
    devicename: '',
    fps: 8,
    IsActive: 1,
    CameraMake: '',
    CameraModel: '',
    LocalHTTPURL: '',
    PublicHTTPURL: '',
    HaveSpeaker: 0,
    BeforeVideo: 10,
    AfterVideo: 60,
    BackupDurationDays: 15,
    Footage: 1,
    IsAgentBased: 1,
    EventsBackupDays: 15,
    EscalatedEventsBackupDays: 90,
    MonitoringStartDate: '',
    MonitoringEndDate: ''
};

const cameraAddSchema = Yup.object().shape({
    server_id: Yup.string().required('Server is required'),
    TimezoneId: Yup.string().required('Time Zone is required'),
    devicename: Yup.string().required('Camera Name is required'),
    substream: Yup.string().required('Sub Stream is required'),
    Footage: Yup.string().required('Footage is required'),
    IsAgentBased: Yup.string().required('Event Send To is required'),
    EventsBackupDays: Yup.string().required('Events Backup Days is required'),
    EscalatedEventsBackupDays: Yup.string().required('Escalated Events Backup Days is required'),
    BeforeVideo: Yup.number().typeError('Before Clip(Sec) is required').required('Before Clip(Sec) is required'),
    AfterVideo: Yup.number().typeError('After Clip(Sec) is required').required('After Clip(Sec) is required'),
});

function CameraAddDialog883({ open, onClose, onSaved }) {
    const [clientOption, setClientOption] = useState(null);
    const [serverDetails, setServerDetails] = useState([]);
    const [timezoneDetails, setTimezoneDetails] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [formDataList, setFormDataList] = useState([{ ...CAMERA_DEFAULT_FORM }]);
    const [formErrors, setFormErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [saveClicked, setSaveClicked] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const hasLocations = locationOptions.length > 0;

    useEffect(() => {
        if (!open) {
            return;
        }

        setIsLoading(true);
        Promise.all([
            new Promise((resolve) => {
                clientApi.getClients((response) => {
                    if (response.status === 200) {
                        const matchedClient = (response.data || []).find((client) => String(client.ID) === '883');
                        setClientOption(matchedClient || null);
                        setFormDataList((prev) =>
                            prev.map((item) => ({
                                ...item,
                                clientid: '883',
                                TimezoneId: matchedClient?.TimezoneId ? String(matchedClient.TimezoneId) : item.TimezoneId,
                                MonitoringStartDate: matchedClient?.MonitoringStartDate || item.MonitoringStartDate,
                                MonitoringEndDate: matchedClient?.MonitoringEndDate || item.MonitoringEndDate,
                            }))
                        );
                    }
                    resolve();
                });
            }),
            new Promise((resolve) => {
                getServerList((response) => {
                    if (response.status === 200) {
                        setServerDetails(response.data || []);
                    }
                    resolve();
                });
            }),
            new Promise((resolve) => {
                getTimezoneList((response) => {
                    if (response.status === 200) {
                        setTimezoneDetails(response.data || []);
                    }
                    resolve();
                });
            }),
            new Promise((resolve) => {
                getClientProperties({ AssignClient: '883' }, (response) => {
                    if (response.status === 200) {
                        const normalizedLocations = Array.from(
                            new Map(
                                (Array.isArray(response.data) ? response.data : (response.data ? [response.data] : []))
                                    .map((locationItem) => ({
                                        ...locationItem,
                                        ID: Number(locationItem?.ID ?? locationItem?.id ?? 0),
                                        Location: String(locationItem?.Location || locationItem?.name || '').trim(),
                                    }))
                                    .filter((locationItem) => locationItem.ID > 0)
                                    .map((locationItem) => [locationItem.ID, locationItem])
                            ).values()
                        );
                        setLocationOptions(normalizedLocations);
                    } else {
                        setLocationOptions([]);
                    }
                    resolve();
                });
            }),
        ]).finally(() => setIsLoading(false));
    }, [open]);

    const resetDialog = () => {
        setFormDataList([{ ...CAMERA_DEFAULT_FORM }]);
        setFormErrors({});
        setErrorMessage('');
        setIsSubmitting(false);
        setSaveClicked(false);
    };

    const handleClose = () => {
        resetDialog();
        onClose();
    };

    const handleAddCamera = () => {
        const firstForm = formDataList[0] || CAMERA_DEFAULT_FORM;
        setFormDataList((prev) => ([
            ...prev,
            {
                ...CAMERA_DEFAULT_FORM,
                clientid: '883',
                locationid: firstForm.locationid || '',
                server_id: firstForm.server_id || '',
                TimezoneId: firstForm.TimezoneId || '',
                Category: firstForm.Category || '2',
                fps: firstForm.fps || 8,
                IsActive: firstForm.IsActive,
                BackupDurationDays: firstForm.BackupDurationDays || 15,
                Footage: firstForm.Footage || 1,
                IsAgentBased: firstForm.IsAgentBased || 1,
                EventsBackupDays: firstForm.EventsBackupDays || 15,
                EscalatedEventsBackupDays: firstForm.EscalatedEventsBackupDays || 90,
                BeforeVideo: firstForm.BeforeVideo || 10,
                AfterVideo: firstForm.AfterVideo || 60,
                MonitoringStartDate: firstForm.MonitoringStartDate || '',
                MonitoringEndDate: firstForm.MonitoringEndDate || '',
            }
        ]));
    };

    const handleRemoveCamera = () => {
        if (formDataList.length === 1) {
            return;
        }
        setFormDataList((prev) => prev.slice(0, -1));
    };

    const handleChange = (index, field) => (event) => {
        const { value } = event.target;
        const isNumberField = ['Serverport', 'fps', 'BackupDurationDays', 'EventsBackupDays', 'EscalatedEventsBackupDays', 'BeforeVideo', 'AfterVideo'].includes(field);
        setFormDataList((prev) => prev.map((item, itemIndex) => (
            itemIndex === index
                ? { ...item, [field]: isNumberField ? (value === '' ? '' : parseInt(value, 10)) : value }
                : item
        )));
        setFormErrors((prev) => ({ ...prev, [`${index}.${field}`]: '' }));
    };

    const handleLocationChange = (index) => (event) => {
        const selectedLocationId = event.target.value;
        setFormDataList((prev) => prev.map((item, itemIndex) => {
            if (itemIndex === index) {
                return { ...item, locationid: selectedLocationId };
            }
            if (index === 0) {
                return { ...item, locationid: selectedLocationId };
            }
            return item;
        }));
        setFormErrors((prev) => ({ ...prev, [`${index}.locationid`]: '' }));
    };

    const handleServerChange = (index) => (event) => {
        const newServerId = event.target.value;
        const selectedServer = serverDetails.find((server) => String(server.Id) === String(newServerId));
        setFormDataList((prev) => prev.map((item, itemIndex) => (
            itemIndex === index ? { ...item, server_id: newServerId } : item
        )));

        if (selectedServer) {
            const capacity = selectedServer.CameraCapacity;
            const existingCount = selectedServer.devices_count;
            const count = formDataList.filter((item) => String(item.server_id) === String(newServerId)).length;
            const newCount = existingCount + count + 1;
            if (newCount > capacity && capacity > 0) {
                setFormErrors((prev) => ({
                    ...prev,
                    [`${index}.server_id`]: `Cannot add more devices. Camera capacity (${selectedServer.CameraCapacity}) exceeded.`
                }));
                return;
            }
        }

        setFormErrors((prev) => ({ ...prev, [`${index}.server_id`]: '' }));
    };

    const handleTimezoneChange = (index) => (event) => {
        setFormDataList((prev) => prev.map((item, itemIndex) => (
            itemIndex === index ? { ...item, TimezoneId: event.target.value } : item
        )));
        setFormErrors((prev) => ({ ...prev, [`${index}.TimezoneId`]: '' }));
    };

    const handleSwitchChange = (index, field) => (event) => {
        const value = event.target.checked ? 1 : 0;
        setFormDataList((prev) => prev.map((item, itemIndex) => (
            itemIndex === index ? { ...item, [field]: value } : item
        )));
        if (field === 'IsActive' && value === 0) {
            setFormErrors((prev) => ({ ...prev, [`${index}.BackupDurationDays`]: '' }));
        }
    };

    const validateForm = async () => {
        const nextErrors = {};
        for (let index = 0; index < formDataList.length; index += 1) {
            const formData = formDataList[index];
            if (hasLocations && !String(formData.locationid || '').trim()) {
                nextErrors[`${index}.locationid`] = 'Location is required';
            }

            if (formData.IsActive && (!formData.BackupDurationDays || Number(formData.BackupDurationDays) < 1 || Number(formData.BackupDurationDays) > 30)) {
                nextErrors[`${index}.BackupDurationDays`] = 'Backup Duration Days must be between 1 and 30';
            }

            try {
                await cameraAddSchema.validate(
                    {
                        ...formData,
                        Footage: String(formData.Footage ?? ''),
                        IsAgentBased: String(formData.IsAgentBased ?? ''),
                        EventsBackupDays: String(formData.EventsBackupDays ?? ''),
                        EscalatedEventsBackupDays: String(formData.EscalatedEventsBackupDays ?? ''),
                        server_id: String(formData.server_id ?? ''),
                        TimezoneId: String(formData.TimezoneId ?? ''),
                    },
                    { abortEarly: false }
                );
            } catch (errors) {
                errors.inner.forEach((error) => {
                    nextErrors[`${index}.${error.path}`] = error.message;
                });
            }
        }

        setFormErrors(nextErrors);
        return Object.keys(nextErrors).length === 0;
    };

    const handleSubmit = async () => {
        setIsSubmitting(true);
        setErrorMessage('');
        setSaveClicked(true);

        const isValid = await validateForm();
        if (!isValid) {
            setIsSubmitting(false);
            return;
        }

        const formattedPayload = formDataList.map((formData) => ({
                ...formData,
                clientid: String(formData.locationid || formData.clientid),
                ...(formData.locationid ? { Locations: String(formData.locationid) } : {}),
                Serverport: formData.Serverport !== '' ? parseInt(formData.Serverport, 10) : null,
                fps: formData.fps !== '' ? parseInt(formData.fps, 10) : null,
                Category: formData.Category === '' ? '0' : formData.Category || '0',
                BackupDurationDays: formData.BackupDurationDays !== '' ? parseInt(formData.BackupDurationDays, 10) : null
        }));

        const doCreateCamera = () => {
            setNewDevice((response) => {
                if (response.status === 200 || response.status === 201) {
                    onSaved();
                    handleClose();
                } else {
                    setIsSubmitting(false);
                }
            }, formattedPayload);
        };

        if (formDataList.some((item) => item.locationid)) {
            getCamerasList((cameraResponse) => {
                if (cameraResponse.status === 200) {
                    const existingCameras = cameraResponse.data || [];
                    const hasOlderCamerasWithoutLocation = existingCameras.some((cam) => {
                        const cameraClientId = Number(cam.clientid || cam.client_id || 0);
                        const cameraLocation = String(cam.Location ?? '').trim();
                        return cameraClientId === 883 && cameraLocation === '';
                    });

                    if (hasOlderCamerasWithoutLocation) {
                        setIsSubmitting(false);
                        setErrorMessage('Before adding a location to a new camera, please assign locations to existing cameras. Only after updating existing cameras can you add locations to new cameras.');
                        return;
                    }
                }

                doCreateCamera();
            });
            return;
        }

        doCreateCamera();
    };

    return (
        <Dialog fullWidth maxWidth="xl" open={open} onClose={handleClose}>
            <DialogTitle>Add/Edit Camera</DialogTitle>
            <DialogContent sx={{ "& .MuiFormLabel-asterisk": { color: "error.main" } }}>
                {isLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        {errorMessage ? (
                            <Alert severity="warning" sx={{ mb: 2 }}>
                                {errorMessage}
                            </Alert>
                        ) : null}
                        <LoadingButton
                            onClick={handleRemoveCamera}
                            color="error"
                            variant="outlined"
                            startIcon={<Iconify icon="eva:minus-fill" />}
                            sx={{ position: "absolute", top: "20px", right: "90px", minWidth: 40, px: 1 }}
                        />
                        <LoadingButton
                            onClick={handleAddCamera}
                            variant="contained"
                            startIcon={<Iconify icon="eva:plus-fill" />}
                            sx={{ position: "absolute", top: "20px", right: "20px", minWidth: 40 }}
                        >
                            {formDataList.length}
                        </LoadingButton>
                        {formDataList.map((formData, index) => (
                        <Card key={`camera-883-form-${index}`} sx={{ p: 1, mb: 2 }}>
                            <Typography variant="subtitle2" sx={{ my: 2, p: 1, borderRadius: 1 }}>
                                Basic Info
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item md={2}>
                                    <Autocomplete
                                        options={clientOption ? [clientOption] : []}
                                        getOptionLabel={(option) => option?.displayname || ''}
                                        value={clientOption}
                                        disabled
                                        renderInput={(params) => (
                                            <TextField {...params} label="Client Name" required InputLabelProps={{ shrink: true }} />
                                        )}
                                    />
                                </Grid>
                                {hasLocations && (
                                    <Grid item md={2}>
                                        <FormControl fullWidth required error={!!formErrors[`${index}.locationid`]}>
                                            <InputLabel
                                                id={`camera-location-label-${index}`}
                                                shrink
                                                sx={{ px: 0.5, backgroundColor: 'background.paper' }}
                                            >
                                                Location
                                            </InputLabel>
                                            <Select
                                                labelId={`camera-location-label-${index}`}
                                                id={`camera-location-${index}`}
                                                value={formData.locationid || ''}
                                                label="Location"
                                                onChange={handleLocationChange(index)}
                                            >
                                                {locationOptions.map((loc) => (
                                                    <MenuItem key={loc.ID} value={loc.ID}>{loc.Location}</MenuItem>
                                                ))}
                                            </Select>
                                            <FormHelperText>{formErrors[`${index}.locationid`] || ''}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                )}
                                <Grid item md={2}>
                                    <FormControl fullWidth>
                                        <InputLabel
                                            id={`camera-view-label-${index}`}
                                            shrink
                                            sx={{ px: 0.5, backgroundColor: 'background.paper' }}
                                        >
                                            Camera View
                                        </InputLabel>
                                        <Select
                                            labelId={`camera-view-label-${index}`}
                                            id={`camera-view-${index}`}
                                            value={formData.CameraView}
                                            label="Camera View"
                                            onChange={handleChange(index, 'CameraView')}
                                        >
                                            <MenuItem value="In Door">In Door</MenuItem>
                                            <MenuItem value="Out Door">Out Door</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                {/* <Grid item md={2}>
                                    <FormControl fullWidth>
                                        <InputLabel
                                            id={`camera-category-label-${index}`}
                                            shrink
                                            sx={{ px: 0.5, backgroundColor: 'background.paper' }}
                                        >
                                            Category
                                        </InputLabel>
                                        <Select
                                            labelId={`camera-category-label-${index}`}
                                            id={`camera-category-${index}`}
                                            value={formData.Category || '0'}
                                            label="Category"
                                            onChange={handleChange(index, 'Category')}
                                        >
                                            <MenuItem value="0">Not Assigned</MenuItem>
                                            <MenuItem value="1">Category 1</MenuItem>
                                            <MenuItem value="2">Category 2</MenuItem>
                                            <MenuItem value="3">Category 3</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid> */}
                                {/* <Grid item md={2}>
                                    <FormControl fullWidth required error={!!formErrors[`${index}.TimezoneId`]}>
                                        <InputLabel
                                            id={`camera-timezone-label-${index}`}
                                            shrink
                                            sx={{ px: 0.5, backgroundColor: 'background.paper' }}
                                        >
                                            Time Zone
                                        </InputLabel>
                                        <Select
                                            labelId={`camera-timezone-label-${index}`}
                                            id={`camera-timezone-${index}`}
                                            value={formData.TimezoneId}
                                            label="Time Zone"
                                            onChange={handleTimezoneChange(index)}
                                        >
                                            {timezoneDetails.map((option) => (
                                                <MenuItem key={option.Id} value={option.Id}>{option.TimeZone}</MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText>{formErrors[`${index}.TimezoneId`] || ''}</FormHelperText>
                                    </FormControl>
                                </Grid> */}
                                <Grid item md={2}>
                                    <TextField fullWidth label="Camera Name" required InputLabelProps={{ shrink: true }} value={formData.devicename} onChange={handleChange(index, 'devicename')} error={!!formErrors[`${index}.devicename`]} helperText={formErrors[`${index}.devicename`] || ''} />
                                </Grid>
                                <Grid item md={2}>
                                    <TextField fullWidth label="Server Port" type="number" InputLabelProps={{ shrink: true }} value={formData.Serverport} onChange={handleChange(index, 'Serverport')} />
                                </Grid>
                                <Grid item md={2}>
                                    <TextField fullWidth label="Main Stream" InputLabelProps={{ shrink: true }} value={formData.MainStream} onChange={handleChange(index, 'MainStream')} />
                                </Grid>
                                <Grid item md={2}>
                                    <TextField fullWidth label="Sub Stream" required InputLabelProps={{ shrink: true }} value={formData.substream} onChange={handleChange(index, 'substream')} error={!!formErrors[`${index}.substream`]} helperText={formErrors[`${index}.substream`] || ''} />
                                </Grid>
                                <Grid item md={2}>
                                    <TextField fullWidth label="ReStream" InputLabelProps={{ shrink: true }} value={formData.ReStream} onChange={handleChange(index, 'ReStream')} />
                                </Grid>
                                <Grid item md={2}>
                                    <FormControl fullWidth required error={!!formErrors[`${index}.server_id`]}>
                                        <InputLabel
                                            id={`camera-server-label-${index}`}
                                            shrink
                                            sx={{ px: 0.5, backgroundColor: 'background.paper' }}
                                        >
                                            Server
                                        </InputLabel>
                                        <Select
                                            labelId={`camera-server-label-${index}`}
                                            id={`camera-server-${index}`}
                                            value={formData.server_id}
                                            label="Server"
                                            onChange={handleServerChange(index)}
                                        >
                                            {serverDetails.map((option) => (
                                                <MenuItem key={option.Id} value={option.Id}>{option.ServerName}</MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText>{formErrors[`${index}.server_id`] || ''}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item md={2}>
                                    <TextField fullWidth label="Frames Per Second (fps)" type="number" value={formData.fps || 8} onChange={handleChange(index, 'fps')} />
                                </Grid>
                                <Grid item md={2}>
                                    <FormControl fullWidth required error={!!formErrors[`${index}.Footage`]}>
                                        <InputLabel
                                            id={`camera-footage-label-${index}`}
                                            shrink
                                            sx={{ px: 0.5, backgroundColor: 'background.paper' }}
                                        >
                                            Footage
                                        </InputLabel>
                                        <Select
                                            labelId={`camera-footage-label-${index}`}
                                            id={`camera-footage-${index}`}
                                            value={String(formData.Footage ?? '1')}
                                            label="Footage"
                                            onChange={handleChange(index, 'Footage')}
                                        >
                                            <MenuItem value="">Select</MenuItem>
                                            <MenuItem value="0">Image</MenuItem>
                                            <MenuItem value="1">Video</MenuItem>
                                        </Select>
                                        <FormHelperText>{formErrors[`${index}.Footage`] || ''}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                {/* <Grid item md={2}>
                                    <FormControl fullWidth required error={!!formErrors[`${index}.IsAgentBased`]}>
                                        <InputLabel
                                            id={`camera-event-send-to-label-${index}`}
                                            shrink
                                            sx={{ px: 0.5, backgroundColor: 'background.paper' }}
                                        >
                                            Event Send To
                                        </InputLabel>
                                        <Select
                                            labelId={`camera-event-send-to-label-${index}`}
                                            id={`camera-event-send-to-${index}`}
                                            value={String(formData.IsAgentBased ?? '1')}
                                            label="Event Send To"
                                            onChange={handleChange(index, 'IsAgentBased')}
                                        >
                                            <MenuItem value="">Select</MenuItem>
                                            <MenuItem value="1">Tier 1</MenuItem>
                                            <MenuItem value="0">Client</MenuItem>
                                        </Select>
                                        <FormHelperText>{formErrors[`${index}.IsAgentBased`] || ''}</FormHelperText>
                                    </FormControl>
                                </Grid> */}
                                <Grid item md={2}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Monitoring Start Date"
                                            value={formData.MonitoringStartDate ? dayjs(formData.MonitoringStartDate) : null}
                                            onChange={(newValue) => setFormDataList((prev) => prev.map((item, itemIndex) => itemIndex === index ? { ...item, MonitoringStartDate: newValue ? newValue.format('YYYY-MM-DD') : '' } : item))}
                                            slotProps={{ textField: { fullWidth: true, InputLabelProps: { shrink: true } } }}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item md={2}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Monitoring End Date"
                                            value={formData.MonitoringEndDate ? dayjs(formData.MonitoringEndDate) : null}
                                            minDate={formData.MonitoringStartDate ? dayjs(formData.MonitoringStartDate) : null}
                                            onChange={(newValue) => setFormDataList((prev) => prev.map((item, itemIndex) => itemIndex === index ? { ...item, MonitoringEndDate: newValue ? newValue.format('YYYY-MM-DD') : '' } : item))}
                                            slotProps={{ textField: { fullWidth: true, InputLabelProps: { shrink: true } } }}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item md={2}>
                                    <FormControlLabel control={<Switch color="success" checked={formData.IsActive === 1} onChange={handleSwitchChange(index, 'IsActive')} />} label="Is Need Archives" />
                                </Grid>
                                {formData.IsActive ? (
                                    <Grid item md={2}>
                                        <TextField fullWidth label="Archives Backup Days" type="number" required InputLabelProps={{ shrink: true }} value={formData.BackupDurationDays || 15} onChange={handleChange(index, 'BackupDurationDays')} error={!!formErrors[`${index}.BackupDurationDays`]} helperText={formErrors[`${index}.BackupDurationDays`] || ''} inputProps={{ min: 1, max: 30 }} />
                                    </Grid>
                                ) : null}
                                <Grid item md={2}>
                                    <TextField fullWidth label="Events Backup Days" type="number" required InputLabelProps={{ shrink: true }} value={formData.EventsBackupDays || 15} onChange={handleChange(index, 'EventsBackupDays')} error={!!formErrors[`${index}.EventsBackupDays`]} helperText={formErrors[`${index}.EventsBackupDays`] || ''} />
                                </Grid>
                                <Grid item md={2}>
                                    <TextField fullWidth label="Escalated Events Backup Days" type="number" required InputLabelProps={{ shrink: true }} value={formData.EscalatedEventsBackupDays || 90} onChange={handleChange(index, 'EscalatedEventsBackupDays')} error={!!formErrors[`${index}.EscalatedEventsBackupDays`]} helperText={formErrors[`${index}.EscalatedEventsBackupDays`] || ''} />
                                </Grid>
                                <Grid item md={2}>
                                    <TextField fullWidth label="Before Clip(Sec)" type="number" required InputLabelProps={{ shrink: true }} value={formData.BeforeVideo ?? ''} onChange={handleChange(index, 'BeforeVideo')} error={!!formErrors[`${index}.BeforeVideo`]} helperText={formErrors[`${index}.BeforeVideo`] || ''} />
                                </Grid>
                                <Grid item md={2}>
                                    <TextField fullWidth label="After Clip(Sec)" type="number" required InputLabelProps={{ shrink: true }} value={formData.AfterVideo ?? ''} onChange={handleChange(index, 'AfterVideo')} error={!!formErrors[`${index}.AfterVideo`]} helperText={formErrors[`${index}.AfterVideo`] || ''} />
                                </Grid>
                            </Grid>
                            <Typography variant="subtitle2" sx={{ my: 2 }}>
                                Camera Configuration
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item md={2}>
                                    <TextField fullWidth label="Camera Make" InputLabelProps={{ shrink: true }} value={formData.CameraMake} onChange={handleChange(index, 'CameraMake')} />
                                </Grid>
                                <Grid item md={2}>
                                    <TextField fullWidth label="Camera Model" InputLabelProps={{ shrink: true }} value={formData.CameraModel} onChange={handleChange(index, 'CameraModel')} />
                                </Grid>
                                <Grid item md={2}>
                                    <TextField fullWidth label="Local HTTP URL" InputLabelProps={{ shrink: true }} value={formData.LocalHTTPURL} onChange={handleChange(index, 'LocalHTTPURL')} />
                                </Grid>
                                <Grid item md={2}>
                                    <TextField fullWidth label="Public HTTP URL" InputLabelProps={{ shrink: true }} value={formData.PublicHTTPURL} onChange={handleChange(index, 'PublicHTTPURL')} />
                                </Grid>
                                <Grid item md={2}>
                                    <FormControlLabel control={<Switch color="success" checked={formData.HaveSpeaker === 1} onChange={handleSwitchChange(index, 'HaveSpeaker')} />} label="Speaker" />
                                </Grid>
                            </Grid>
                        </Card>
                        ))}
                    </>
                )}
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button color="inherit" onClick={handleClose}>Cancel</Button>
                <LoadingButton variant="contained" loading={isSubmitting} onClick={handleSubmit}>Save</LoadingButton>
            </DialogActions>
        </Dialog>
    );
}

export default function Cameras() {
    const [searchParams, setSearchParams] = useSearchParams();
    const hasAppliedStatusFromQuery = useRef(false);
    const [page, setPage] = useState(0);

    const [order, setOrder] = useState('asc');

    const [selected, setSelected] = useState([]);

    const [orderBy, setOrderBy] = useState('name');

    const [filterName, setFilterName] = useState('');
    const [cameraStatusFilter, setCameraStatusFilter] = useState('all');

    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [formDialog, setFromDialog] = useState({
        open: false,
        id: null,
        devicename: '',
        substream: ''
    });
    const [deviceDialogOpen, setDeviceDialogOpen] = useState(false);

    const clientId = localStorage.getItem('client_id');
    console.log(clientId)

    useEffect(() => {
      
        if (clientId !== '883') {
            return;
        }

        const statusFromQuery = searchParams.get('status');
        const allowedStatuses = ['all', 'online', 'offline'];

        if (!hasAppliedStatusFromQuery.current && allowedStatuses.includes(statusFromQuery) && statusFromQuery !== cameraStatusFilter) {
            setCameraStatusFilter(statusFromQuery);
            setPage(0);
            hasAppliedStatusFromQuery.current = true;
        }
    }, [cameraStatusFilter, clientId, searchParams]);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = alldata.data.map((n) => n.devicename);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleFilterByName = (event) => {
        setFilterName(event.target.value);
        setPage(0);
    };

    const handleCameraStatusFilter = (event) => {
        setCameraStatusFilter(event.target.value);
        setPage(0);

        if (clientId === '883' && searchParams.get('status')) {
            const nextSearchParams = new URLSearchParams(searchParams);
            nextSearchParams.delete('status');
            setSearchParams(nextSearchParams);
        }
    };

    const {
        alldata,
        addCamera,
        isLoadForm,
        isReloadData,
        updateStatus,
        deleteRecord
    } = useCameras()

    // console.log('locations', locations)


    const searchedCameras = applySortFilter(alldata.data, getComparator(order, orderBy), filterName);
    const filteredCameras = clientId === '883'
        ? searchedCameras.filter((camera) => {
            if (cameraStatusFilter === 'all') {
                return true;
            }
            return cameraStatusFilter === 'online'
                ? Number(camera.Status) === 1
                : Number(camera.Status) !== 1;
        })
        : searchedCameras;
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredCameras.length) : 0;

    const isUserNotFound = filteredCameras.length === 0;


    function handleDialog() {
        setFromDialog({...formDialog, id: null, open: true})
    }

    const [ confirmalert, setAlert ] = useState({
        title: '',
        content: '',
        open: false,
        id: null,
        status: null
    })

    const handleAlertClose = () => setAlert({...confirmalert, open:false})

    const handleAlertOpen = (id, status) => {
        
        let title = status === 0 ? 'InActive Alert' : 'Delete Alert'
        let content = status === 0 ? 'Are you sure want to inactive this record': 'Are you sure want to delete this record'
        setAlert({
            title: title,
            content: content,
            open: status !== 1,
            id: id,
            status: status
        })
        if (status === 1)
            handleStatus(id, status)
        
    }

    const handleStatus = (id, status) => {
        let body = { uid: id }
        if (status !== 2) {
            body.Status = status            
            updateStatus(body)
        } else 
            deleteRecord(body)

        handleAlertClose()
        isReloadData(true)        
    }

    function copyTextToClipboard(text) {
        try {
            if(navigator.clipboard) {
                navigator.clipboard.writeText(text).then(() => {
                    // console.log('Text has been copied to the clipboard');
                })
            }          
        } catch (err) {
            console.error('Unable to copy text to clipboard');
        }      
    }

    const handlePlay = (stream) => {
        try {
            window.JSBridge.showMessageInNative(stream)
        } catch (e) {
            copyTextToClipboard(stream);
        }
        
            
        // callHandler("callNativeMethod", stream, function (resp) {
        //     console.log("from js to native " + resp);
        //   })
    }

    return (
        <Page title="Cameras">
             <Container maxWidth="xxl" sx={{ p: 0 }}>
                <CameraAlert
                alert={confirmalert.open}
                handleAlertClose={handleAlertClose}
                title={confirmalert.title}
                content={confirmalert.content}
                locationId={confirmalert.id}
                status={confirmalert.status}
                handleStatus={handleStatus}
                />
                <CameraForm
                    formDialog={formDialog}
                    setFromDialog={setFromDialog}
                    alldata={alldata}
                    addCamera={addCamera}
                    isLoadForm={isLoadForm}
                    isReloadData={isReloadData} />
                {clientId === '883' && (
                    <CameraAddDialog883
                        open={deviceDialogOpen}
                        onClose={() => setDeviceDialogOpen(false)}
                        onSaved={() => isReloadData(true)}
                    />
                )}
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Cameras
                    </Typography>
                    
                    {clientId === '883' && (
                        <Button variant="contained" onClick={() => setDeviceDialogOpen(true)} component={RouterLink} to="#" startIcon={<Iconify icon="eva:plus-fill" />}>
                        Add Camera
                         </Button>
                    )}
                    {localStorage.getItem('ID') === '2' && (
                        <Button variant="contained" onClick={handleDialog} component={RouterLink} to="#" startIcon={<Iconify icon="eva:plus-fill" />}>
                        New Camera
                         </Button>
                    )}
                    
                </Stack>

                <Card>
                 <Stack
  direction="row"
  spacing={2}
  sx={{
    justifyContent: "flex-start",
    alignItems: "center",
  }}
>
                    <ListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName}/>
                  
                        {clientId === '883' && (
                            <FormControl sx={{ minWidth: 180 }}>
                                <InputLabel id="camera-status-label">Camera Status</InputLabel>
                                <Select
                                    labelId="camera-status-label"
                                    value={cameraStatusFilter}
                                    label="Camera Status"
                                    onChange={handleCameraStatusFilter}
                                >
                                    <MenuItem value="all">All</MenuItem>
                                    <MenuItem value="online">Online</MenuItem>
                                    <MenuItem value="offline">Offline</MenuItem>
                                </Select>
                            </FormControl>
                        )}
          </Stack>      
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: '10px',
                            px: 0.5,
                            py: 0.5
                        }}
                    >
                    </Box>


                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <ListHead
                                    order={order}
                                    orderBy={orderBy}
                                    headLabel={TABLE_HEAD}
                                    rowCount={alldata.data.length}
                                    numSelected={selected.length}
                                    onRequestSort={handleRequestSort}
                                    onSelectAllClick={handleSelectAllClick}
                                />
                                <TableBody>
                                    {filteredCameras.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                        const { uid, devicename, deviceid, substream, Status } = row;                                        
                                        return (
                                            <TableRow
                                                hover
                                                key={uid}
                                                tabIndex={-1}
                                            >

                                                <TableCell align="left">{deviceid}</TableCell>
                                                <TableCell align="left">{devicename}</TableCell>
                                                <TableCell align="left">{substream}</TableCell>
                                                {/* <TableCell align="left"><Link component="button"
                                                    variant="body2"
                                                    onClick={() => handlePlay(substream)}
                                                    >{substream}</Link></TableCell> */}
                                                <TableCell align="left">
                                                    <Label variant="ghost" color={Number(Status) === 1 ? 'success' : 'error'}>
                                                        {Number(Status) === 1 ? 'Active' : 'InActive'}
                                                    </Label>
                                                </TableCell>
                                                {(localStorage.getItem('ID') === '2') && (
                                                    <TableCell align="center">
                                                        <CameraMoreMenu
                                                        handleAlertOpen={handleAlertOpen}
                                                        uid={uid}
                                                        devicename={devicename}
                                                        substream={substream}
                                                        Status={Status}
                                                        setFromDialog={setFromDialog}
                                                        />
                                                    </TableCell>
                                                )}                                                
                                            </TableRow>
                                        );
                                    })}
                                    {emptyRows > 0 && (
                                        <TableRow style={{ height: 53 * emptyRows }}>
                                            <TableCell colSpan={6} />
                                        </TableRow>
                                    )}
                                </TableBody>

                                {isUserNotFound && (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                                                <SearchNotFound searchQuery={filterName} />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                )}
                            </Table>
                        </TableContainer>
                    </Scrollbar>

                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={filteredCameras.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </Container>
        </Page>
    );
}
